export function customTargetingGroupPath(groupIndex: number) {
  return `customTargetingExt.groups.${String(groupIndex)}` as `customTargetingExt.groups.${number}`;
}

export function customTargetingRulePath(groupIndex: number, ruleIndex: number) {
  return `customTargetingExt.groups.${String(groupIndex)}.rules.${String(
    ruleIndex,
  )}` as `customTargetingExt.groups.${number}.rules.${number}`;
}
